/**
 * Stand-in for the marketing pages while MARKETING_UI_ENABLED is false.
 *
 * Deep links and bookmarks to the marketing destinations still resolve, but
 * land here instead of on a page of failed requests. Deliberately calm: this
 * is a status, not something to act on.
 */
import { Link } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { MARKETING_UI_DORMANT_SINCE } from '@/lib/featureFlags';

interface MarketingDormantProps {
  /** Where the one link goes. Defaults to the app's landing. */
  linkTo?: string;
  linkLabel?: string;
}

export function MarketingDormant({
  linkTo = '/',
  linkLabel = 'Back to Today',
}: MarketingDormantProps) {
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div
        role="status"
        className="max-w-md rounded-lg border border-[var(--border-color)] bg-[var(--surface)] p-8 text-center"
      >
        <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-[var(--surface-hover)]">
          <Megaphone className="h-5 w-5 text-[var(--text-muted)]" aria-hidden="true" />
        </div>
        <h1 className="text-base font-semibold text-[var(--text-primary)]">Marketing is dormant</h1>
        <p className="mt-2 text-sm leading-relaxed text-[var(--text-muted)]">
          Paid and organic marketing were paused on {MARKETING_UI_DORMANT_SINCE}. These pages are
          switched off until marketing resumes.
        </p>
        <Link
          to={linkTo}
          className="mt-5 inline-flex items-center rounded-lg border border-[var(--border-color)] px-3 py-1.5 text-sm text-[var(--text-secondary)] transition-colors hover:bg-[var(--surface-hover)] hover:text-[var(--text-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]"
        >
          {linkLabel}
        </Link>
      </div>
    </div>
  );
}

export default MarketingDormant;
